import React from "react";
import { Growl } from "primereact/growl";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import ServicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from "../servicio/ServicioHttp";
import ServicioArchivos from '../servicio/ServicioArchivos';
import { Lightbox } from 'primereact/lightbox';
import { Paginator } from 'primereact/paginator';
import { Message } from 'primereact/message';
import { isIE } from '../servicio/ServicioCodificacionArchivos';
import servicioFormatos from '../servicio/ServicioFormatos';
import '../componentes/Iframe.css';
import servicioObjetos from "../servicio/ServicioObjetos";

const JOIN_PRINCIPAL = {
    "tcEmpresas": "alias_tcEmpresa"
};
export class ConsultaMovimientosIndividual extends React.Component {
    constructor() {
        super();
        this.state = {
            digitoVerificador: null,
            criterio: {},
            iFrameSrc: null,
            vistaBusqueda: true,
            tcTrabajador: {},
            labelTrabajador: {},
            errores: {},
            paginacion: { registrosPorPagina: 20 },
            idsenube: 0,
            paginacionMovimientos: { registrosPorPagina: 20 },
            idsenubeMovimientos: 0,
        }
        this.obtenerRegistrosPatronales();
    }
    asignarValores = (event, mayusculas) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, mayusculas);
    };

    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            this.setState({ registrosPatronales: response.data.lista });
        }).catch(error => {

        });
    };

    busquedaGeneral = () => {
        let { paginacion, registrosPatronales, tcTrabajador } = this.state;
        const validacion = this.validarFormulario(tcTrabajador);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            paginacion.join = JOIN_PRINCIPAL;
            paginacion.restriccionesDinamicas = [];

            if(!ServicioObjetos.esObjetoVacio(tcTrabajador.numeroSeguridadSocial)){
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "numeroSeguridadSocial",
                    valorPropiedad: tcTrabajador.numeroSeguridadSocial
                });
            }else{
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "nombre",
                    valorPropiedad: tcTrabajador.nombre
                });
    
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "primerApellido",
                    valorPropiedad: tcTrabajador.primerApellido
                });
    
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "segundoApellido",
                    valorPropiedad: tcTrabajador.segundoApellido
                });
            }
                        
            let empresasUsuarioSesion = [];
            for (let index = 0; index < registrosPatronales.length; index++) {
                let elemento = registrosPatronales[index];
                if (elemento.value !== 0) {
                    let valor = elemento.value;
                    empresasUsuarioSesion.push(
                        valor
                    );
                }
            }
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "in",
                nombrePropiedad: "alias_tcEmpresa.id",
                coleccionIn: empresasUsuarioSesion
            });
            this.setState({ paginacion: paginacion });
            this.obtenerResultados();
        }
    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.busquedaGeneral();
    }

    obtenerResultados = () => {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp("trabajador/consulta.json", paginacion).then((response) => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(() => { });
    }

    obtenerResultadosMovimientos = () => {
        let { paginacionMovimientos } = this.state;
        servicioHttp.consumirPostHttp("movimientos/consulta_individual.json", paginacionMovimientos).then((response) => {
            this.setState({ paginacionMovimientos: response.data.objeto, vistaBusqueda: false });
        }).catch(() => { });
    }
    cambiaPaginaMovimientos = (event) => {
        let { paginacionMovimientos } = this.state;
        paginacionMovimientos.numeroPagina = event.page;
        paginacionMovimientos.registrosPorPagina = event.rows;
        this.setState({ idsenubeMovimientos: event.first, paginacionMovimientos });
        this.obtenerResultadosMovimientos();
    }

    borrarBusqueda = () => {
        this.setState({ tcTrabajador: {}, paginacion: { registrosPorPagina: 20 } });
    };

    validarFormulario = (tcTrabajador) => {
        const errores = {};
        if(ServicioObjetos.esObjetoVacio(tcTrabajador.numeroSeguridadSocial) && ServicioObjetos.esObjetoVacio(tcTrabajador.nombre) && ServicioObjetos.esObjetoVacio(tcTrabajador.primerApellido) && ServicioObjetos.esObjetoVacio(tcTrabajador.segundoApellido)){
            errores.numeroSeguridadSocial="Campo requerido"
            errores.nombre = "Campo requerido";
            errores.primerApellido = "Campo requerido";
            errores.segundoApellido = "Campo requerido";
        }

        if(!ServicioObjetos.esObjetoVacio(tcTrabajador.numeroSeguridadSocial) && !ServicioObjetos.esObjetoVacio(tcTrabajador.nombre) && !ServicioObjetos.esObjetoVacio(tcTrabajador.primerApellido) && !ServicioObjetos.esObjetoVacio(tcTrabajador.segundoApellido)){
            errores.numeroSeguridadSocial="No pueden estar llenos todos los campos"
            errores.nombre = "No pueden estar llenos todos los campos";
            errores.primerApellido = "No pueden estar llenos todos los campos";
            errores.segundoApellido = "No pueden estar llenos todos los campos";
        }

        if(ServicioObjetos.esObjetoVacio(tcTrabajador.numeroSeguridadSocial) && (ServicioObjetos.esObjetoVacio(tcTrabajador.nombre) || ServicioObjetos.esObjetoVacio(tcTrabajador.primerApellido) || ServicioObjetos.esObjetoVacio(tcTrabajador.segundoApellido))){
            errores.nombre = "Campo requerido";
            errores.primerApellido = "Campo requerido";
            errores.segundoApellido = "Campo requerido";         
        }

        if(!ServicioObjetos.esObjetoVacio(tcTrabajador.numeroSeguridadSocial) && (!ServicioObjetos.esObjetoVacio(tcTrabajador.nombre) || !ServicioObjetos.esObjetoVacio(tcTrabajador.primerApellido) || !ServicioObjetos.esObjetoVacio(tcTrabajador.segundoApellido))){
            errores.nombre = "Campo no requerido";
            errores.primerApellido = "Campo no requerido";
            errores.segundoApellido = "Campo no requerido";         
        }
        return errores;
    };
    mostrarDetalle = (objeto) => {
        let { labelTrabajador, paginacionMovimientos } = this.state;
        labelTrabajador.nombre = objeto.nombre + " " + objeto.primerApellido + " " + objeto.segundoApellido;
        labelTrabajador.numeroSeguridadSocial = objeto.numeroSeguridadSocial;
        paginacionMovimientos.restriccionesDinamicas = [];

        paginacionMovimientos.restriccionesDinamicas.push({
            tipoRestriccion: "eq",
            nombrePropiedad: "alias_tcTrabajador.numeroSeguridadSocial",
            valorPropiedad: objeto.numeroSeguridadSocial,
        });
        this.obtenerResultadosMovimientos();

    }
    regresaVista = () => {
        this.setState({ vistaBusqueda: true });
    }
    plantillaOpciones(rowData, column) {

        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-12">
                    <Button
                        type="button"
                        onClick={(e) => this.mostrarDetalle(column.rowData)}
                        name="Consultar"
                        label="Consultar"
                        tooltip="Consultar"
                        icon="pi-md-search"
                    ></Button>
                </div>
            </div>
        );
    }
    columnaBotonAcuse(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-12">
                    <Button
                        type="button"
                        onClick={(e) => this.visorAcuse(column.rowData)}
                        name="Acuse"
                        label="Acuse"
                        tooltip="Acuse"
                        icon="pi-md-folder"
                    ></Button>
                </div>
            </div>
        );

    }
    columnaBotonConstancia(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-12">
                    <Button
                        type="button"
                        onClick={(e) => this.visorAfil(column.rowData)}
                        name="constancia"
                        label="constancia"
                        tooltip="constancia"
                        icon="pi-md-folder"
                    ></Button>
                </div>
            </div>
        );

    }
    columnaBotonAcuseIndividual(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-12">
                    <Button
                        type="button"
                        onClick={(e) => this.visorAfilIndividual(column.rowData)}
                        name="constancia Individual"
                        label="C. Individual"
                        tooltip="Constancia Individual"
                        icon="pi-md-folder"
                    ></Button>
                </div>
            </div>
        );

    }
    descargaExcel = () => {
        let { labelTrabajador } = this.state;
        ServicioArchivos.descargaArchivo('/documentos/reporte_consulta_individual.json', { numeroSeguridadSocial: labelTrabajador.numeroSeguridadSocial });
    }
    descargaPdf = (objeto) => {
        let { labelTrabajador } = this.state;
        ServicioArchivos.descargaArchivo('/documentos/pdf_consulta_individual.json', { numeroSeguridadSocial: labelTrabajador.numeroSeguridadSocial });
    }
    visorAcuse = (objeto) => {
        if (isIE()) {
            ServicioArchivos.descargaArchivo('/documentos/descarga_acuse.json', { archivoAcuseRecibo: objeto.archivoAcuseRecibo });
        } else {
            ServicioArchivos.descargaArchivoComoBlob('/documentos/descarga_acuse.json', { archivoAcuseRecibo: objeto.archivoAcuseRecibo })
                .then((response) => {
                    this.setState({ iFrameSrc: URL.createObjectURL(response) });
                    document.getElementById("btnVisorPdfTarget").click();
                }).catch((error) => {
                    console.log(error);
                    this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se encutra el archivo' });
                });
        }

    }
    visorAfil = (objeto) => {
        if (isIE()) {
            ServicioArchivos.descargaArchivo('/documentos/descarga_acuse.json', { archivoAcuseRecibo: objeto.archivoAfil });
        } else {
            ServicioArchivos.descargaArchivoComoBlob('/documentos/descarga_acuse.json', { archivoAcuseRecibo: objeto.archivoAfil })
                .then((response) => {
                    this.setState({ iFrameSrc: URL.createObjectURL(response) });
                    document.getElementById("btnVisorPdfTarget").click();
                }).catch((error) => {
                    console.log(error);
                    this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se encutra el archivo' });
                });
        }

    }
    visorAfilIndividual = (objeto) => {
        if (isIE()) {
            ServicioArchivos.descargaArchivo("/documentos/afil_individual.json", { id: objeto.id });
        } else {
            ServicioArchivos.descargaArchivoComoBlob("/documentos/afil_individual.json", { id: objeto.id })
                .then((response) => {
                    this.setState({ iFrameSrc: URL.createObjectURL(response) });
                    document.getElementById("btnVisorPdfTarget").click();
                }).catch((error) => {
                    console.log(error);
                    this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se encutra el archivo' });
                });
        }

    }
    plantillaTipoTrabajador(rowData, column) {
        if (column.rowData.tipoTrabajador === "0")
            return <p >{"Permanente"}</p>
        if (column.rowData.tipoTrabajador === "1")
            return <p >{"Eventual"}</p>
        if (column.rowData.tipoTrabajador === "2")
            return <p >{"Eventual de la Construcción"}</p>
    }
    plantillaTipoMovimiento = (rowData, column) => {
        if (rowData.tipoMovimiento === "08")
            return <div>Reingreso</div>;
        if (rowData.tipoMovimiento === "07")
            return <div>Modificación</div>;
        if (rowData.tipoMovimiento === "02")
            return <div>Baja</div>;
    }
    plantillaTipoSalario = (rowData, column) => {
        if (rowData.tipoSalario === "0")
            return <div>Salario Fijo</div>;
        if (rowData.tipoSalario === "1")
            return <div>Salario Variable</div>;
        if (rowData.tipoSalario === "2")
            return <div>Salario Mixto</div>;
    }
    plantillaJornadaReducida = (rowData, column) => {
        if (rowData.jornadaReducida === "0")
            return <div>Jornada Normal</div>;
        if (rowData.jornadaReducida === "1")
            return <div>Un día</div>;
        if (rowData.jornadaReducida === "2")
            return <div>Dos días</div>;
        if (rowData.jornadaReducida === "3")
            return <div>Tres días</div>;
        if (rowData.jornadaReducida === "4")
            return <div>Cuatro días</div>;
        if (rowData.jornadaReducida === "5")
            return <div>Cinco días</div>;
        if (rowData.jornadaReducida === "6")
            return <div>Jornada Reducida</div>;
    }
    plantillaEstadoMovimiento = (rowData, column) => {
        if (rowData.descripcionErrorAfil === null && rowData.descripcionError === null && rowData.loteIdImss != null && rowData.estado === 1) {
            return <div>Operación exitosa</div>;
        } else {
            if (rowData.descripcionErrorAfil != null)
                return <div>{rowData.descripcionErrorAfil}</div>;
            if (rowData.descripcionError != null)
                return <div>{rowData.descripcionError}</div>;
        }

    }

    plantillaFechaMovimiento = (rowData, column) => {
        return servicioFormatos.formatearFechaStringIdse(rowData.fechaMovimiento);
    }
    templateSalarioDiario = (rowData, column) => {

        return servicioFormatos.formatoSalarioDiarioIntegradoString(rowData.salarioDiarioIntegrado);
    }
    templateCausaBaja = (rowData, column) => {
        return servicioFormatos.formatoCausaBaja(rowData.causaBaja);
    }
    templateExtemporaneo = (rowData, column) => {
        return servicioFormatos.filtroExtemporaneo(rowData.extemporaneo);
    }

    templateNombre = (rowData, column) => {
        return servicioFormatos.formatearNombreTrabajador(rowData);
    }

    render() {
        let { idsenube, iFrameSrc, tcTrabajador, errores, paginacion, vistaBusqueda, 
            labelTrabajador, paginacionMovimientos } = this.state;
        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );

        let pieTablaExportarEma = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                <Button type="button" className="p-button-secondary" onClick={(e) => this.descargaExcel()} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button>
            </div>
            <div className="p-col-12 p-md-2">
                <Button type="button" className="p-button-secondary" onClick={(e) => this.descargaPdf()} name="pdf" label="PDF" icon="pi-md-import-export" tooltip="Pdf"></Button>
            </div>
        </div>;
        return (

            <div>
                <Growl ref={(el) => (this.growl = el)} />
                <Lightbox target={visorPdfTarget}>
                    <div id="contenedorIframe"  >
                        <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" title="pdf"></iframe>
                    </div>
                </Lightbox>

                {vistaBusqueda === true ?
                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <h1>Consultas por cuenta individual</h1>
                            <div className="p-fluid p-grid">

                                <div className="p-col-12 p-md-3">
                                    <label >Número de Seguridad Social:</label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText type="search" placeholder="NSS" keyfilter="pint" maxLength="11" id="tcTrabajador.numeroSeguridadSocial" name="tcTrabajador.numeroSeguridadSocial" value={tcTrabajador.numeroSeguridadSocial || ""} className={errores.numeroSeguridadSocial ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.numeroSeguridadSocial ? <div><Message severity="error" text={errores.numeroSeguridadSocial} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <h1> <label>Nombre del asegurado</label></h1>
                                </div>
                                <div className="p-col-12 p-md-4">

                                    <InputText type="search" placeholder="Apellido Paterno" id="tcTrabajador.primerApellido" name="tcTrabajador.primerApellido" value={tcTrabajador.primerApellido || ""} className={errores.primerApellido ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.primerApellido ? <div><Message severity="error" text={errores.primerApellido} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-4">

                                    <InputText type="search" placeholder="Apellido Materno" id="tcTrabajador.segundoApellido" name="tcTrabajador.segundoApellido" value={tcTrabajador.segundoApellido || ""} className={errores.segundoApellido ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.segundoApellido ? <div><Message severity="error" text={errores.segundoApellido} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-4">

                                    <InputText type="search" placeholder="Nombre" id="tcTrabajador.nombre" name="tcTrabajador.nombre" value={tcTrabajador.nombre || ""} className={errores.nombre ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.nombre ? <div><Message severity="error" text={errores.nombre} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-12">
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <Button className="p-button-Primary p-button-raised" 
                                    label="Limpiar" icon="pi-md-refresh" onClick={this.borrarBusqueda} 
                                    tooltip={"Borrar"} />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <Button className="p-button-Primary p-button-raised" 
                                    label="Buscar" icon="pi-md-search" onClick={this.busquedaGeneral} 
                                    tooltip={"Buscar"} />
                                </div>

                            </div>
                        </div>
                    </div>
                    : <div>
                        <div className="card card-w-title">
                            <div className="p-fluid p-grid">
                                <div className="p-col-12 p-md-2">
                                    <Button type="button" onClick={(e) => this.regresaVista()} icon="pi-md-arrow-back" name="Regresar" label="Regresar" tooltip="Regresar"></Button>
                                </div>
                                <div className="p-col-12 p-md-10"></div>
                                <div className="p-col-12 p-md-12">
                                    <h1>{labelTrabajador.nombre}</h1>
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <label >Numero de seguridad social: <b>{labelTrabajador.numeroSeguridadSocial}</b></label>
                                </div>
                            </div>
                        </div>
                    </div>}


                {vistaBusqueda === true ? <div className="card card-w-title">
                    <DataTable
                        value={paginacion.datos}
                        editable={true}
                        selectionMode="single"
                        responsive={true}
                        header="Cuenta individual"
                        rows={20}
                    >
                        <Column
                            field="numeroSeguridadSocial"
                            header="NSS"
                            autoLayout={true}
                        />
                        <Column
                            body={this.templateNombre}
                            header="Nombre"
                            autoLayout={true}
                        />
                        <Column
                            header=""
                            body={this.plantillaOpciones.bind(this)}
                            autoLayout={true}
                        />


                    </DataTable>
                    <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div> : <div className="card card-w-title">
                    <DataTable
                        value={paginacionMovimientos.datos}
                        header="Movimientos"
                        rows={20}
                        responsive={true} resizableColumns={true}
                        footer={servicioObjetos.esObjetoVacio(paginacionMovimientos.datos) ? null : pieTablaExportarEma}
                    >
                        <Column field="loteIdImss"
                            header="Lote IMSS"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />
                        <Column
                            field="registroPatronal"
                            header="Registro Patronal"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />
                        <Column
                            body={this.plantillaFechaMovimiento.bind(this)}
                            header="Fecha Movimiento"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />
                        <Column
                            body={this.plantillaTipoMovimiento.bind(this)}
                            header="Tipo Movimiento"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />
                        <Column
                            field="umf"
                            header="UMF"
                            autoLayout={true}
                            style={{ width: '80px' }}
                            resizableColumns={true}
                        />
                        <Column
                            field="claveTrabajador"
                            header="Clave Trabajador"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />
                        <Column
                            body={this.plantillaTipoTrabajador.bind(this)}
                            header="Tipo Trabajador"
                            autoLayout={true}
                            style={{ width: '110px' }}
                            resizableColumns={true}
                        />
                        <Column
                            body={this.templateSalarioDiario}
                            header="SDI"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />

                        <Column
                            body={this.templateExtemporaneo}
                            header="Ext."
                            autoLayout={true}
                            style={{ width: '50px' }}
                            resizableColumns={true}
                        />

                        <Column
                            field={this.plantillaTipoSalario.bind(this)}
                            header="Tipo Salario"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />

                        <Column
                            body={this.plantillaJornadaReducida.bind(this)}
                            header="Jornada"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />
                        <Column
                            body={this.templateCausaBaja}
                            header="Causa Baja"
                            autoLayout={true}
                            style={{ width: '100px' }}
                            resizableColumns={true}
                        />
                        <Column
                            body={this.plantillaEstadoMovimiento.bind(this)}
                            header="Estado"
                            autoLayout={true}
                            style={{ width: '300px' }}
                            resizableColumns={true}
                        />
                        <Column
                            header=""
                            body={this.columnaBotonAcuse.bind(this)}
                            autoLayout={true}
                            style={{ width: '150px' }}
                            resizableColumns={true}
                        />
                        <Column
                            header=""
                            body={this.columnaBotonConstancia.bind(this)}
                            autoLayout={true}
                            style={{ width: '150px' }}
                            resizableColumns={true}
                        />
                        <Column
                            header=""
                            body={this.columnaBotonAcuseIndividual.bind(this)}
                            autoLayout={true}
                            style={{ width: '200px' }}
                            resizableColumns={true}
                        />

                    </DataTable>
                    <Paginator first={idsenube} rows={paginacionMovimientos.registrosPorPagina}
                        totalRecords={paginacionMovimientos.registrosTotales}
                        onPageChange={this.cambiaPaginaMovimientos.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div>}
            </div>
        );
    }
}